import {Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../../../../services/user-services/user.service";
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgClass, DatePipe } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent } from '../../../../../shared/components/icons-svgs/icons-svgs.component';

@Component({
    selector: 'app-accomodation-owner',
    templateUrl: './component-owner.component.html',
    styleUrls: ['./component-owner.component.scss'],
    standalone: true,
    imports: [IconComponent, NgbTooltipModule, NgFor, NgClass, TranslateModule, DatePipe]
})
export class ComponentOwnerComponent implements OnInit {

  @Input() room;
  isMobile;
  languages = [];
  checkInArray: any[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY' ];
  actualIndex: 0;


  constructor(
      private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    this.languages = JSON.parse(this.room.partner.languages);
    this.toggleCheckIn(0);
  }

  toggleCheckIn(index) {
    this.actualIndex = index;
  }

}
